import { render } from "./PretripsGroup.vue?vue&type=template&id=f68fe1fa&scoped=true"
const script = {}

import "./PretripsGroup.vue?vue&type=style&index=0&id=f68fe1fa&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f68fe1fa"]])

export default __exports__